export const TRANSLATIONS = {
  fr: {
    "page.title": "InstaGold Calc — Combien vaut votre or ? | Montréal",
    "nav.home": "Accueil",
    "nav.infos": "Infos",
    "nav.about": "À propos",
    "nav.download": "Télécharger l'app",
    "hero.eyebrow": "InstaGold Calc — Montréal",
    "hero.t1": "Combien vaut",
    "hero.t2a": "votre",
    "hero.t2b": "or",
    "hero.t2c": " ?",
    "hero.sub": "Prix du jour, payé en cash ou par virement.",
    "hero.cta1": "Estimer mon or",
    "hero.cta2": "Télécharger l'application",
    "hero.tutorial": "Voir le tutoriel",
    "common.close": "Fermer le tutoriel",
    "testi.eyebrow": "Ils ont vendu avec nous",
    "testi.title1": "La parole aux",
    "testi.title2": "vendeurs",
    "testi.sub": "Bijoux, pièces de collection, montres et successions — ce que disent les personnes qui nous ont confié leur or.",
    "testi.1.text": "Succession délicate avec des dizaines de pièces. Ils ont tout trié et estimé pièce par pièce en une seule visite. Professionnalisme rare.",
    "testi.2.text": "J'étais nerveuse à l'idée de vendre mes bijoux. On m'a expliqué chaque étape, les tests sans dommage, et j'ai reçu un virement le jour même.",
    "testi.3.text": "Calculatrice du site fidèle à la réalité : mon estimation en ligne et le montant reçu au comptoir étaient identiques. Confiance totale.",
    "marquee.1": "Estimation gratuite",
    "marquee.2": "Paiement cash ou virement",
    "marquee.3": "Or 10K · 14K · 18K · 24K",
    "marquee.4": "Argent sterling",
    "marquee.5": "Confidentialité garantie",
    "marquee.6": "Maison officielle — Encans Desparois",
    "calc.title": "Calculer la valeur de mon or",
    "calc.live": "Cours en direct",
    "calc.ref": "Cours de référence",
    "calc.gold": "Or",
    "calc.silver": "Argent",
    "calc.platinum": "Platine",
    "calc.weight": "Poids",
    "calc.grams": "grammes",
    "calc.metalPrice": "Prix du métal",
    "calc.purity": "Titre",
    "calc.gross": "Valeur brute",
    "calc.rate": "Taux de rachat",
    "calc.estimate": "Estimation payée",
    "calc.disclaimer": "Estimation indicative, sans engagement. Le prix final est confirmé après test de vos articles.",
    "calc.book": "Prendre rendez-vous",
    "calc.modalSub": "Vendez votre or — laissez vos coordonnées, choisissez quand vous venir.",
    "trust.eyebrow": "Pourquoi nous vendre",
    "trust.title1": "La confiance,",
    "trust.title2": "gravée",
    "trust.title3": "dans la transparence.",
    "trust.c1t": "Confidentialité garantie",
    "trust.c1d": "Vos estimations personnelles restent strictement privées.",
    "trust.c2t": "Transparence & Rigueur",
    "trust.c2d": "Évaluations basées sur les cours officiels des métaux précieux.",
    "trust.c3t": "Maison Officielle",
    "trust.c3d": "Transactions encadrées par la maison de ventes aux enchères Encans Desparois.",
    "trust.auctions": "Découvrir nos encans en direct",
    "trust.auctionsSub": "www.encansdesparois.com — bijoux, métaux précieux, objets de collection",
    "banner.eyebrow": "Nous achetons aussi",
    "banner.items": "Œuvres d'art · Pièces de collection · Montres · Timbres · Bijoux · Objets de collection",
    "banner.cta": "Découvrir ce que nous achetons",
    "evo.eyebrow": "L'évolution du prix de l'or",
    "evo.ounce": "CA / once",
    "evo.caption": "L'or a été multiplié par plus de 10 depuis 2005 (en dollars canadiens). C'est le bon moment pour vendre.",
    "evo.chartTitle": "Cours de l'or — 25 ans ($ CA / once)",
    "evo.chartSub": "Moyennes mensuelles",
    "dlapp.eyebrow": "L'application mobile",
    "dlapp.title2": "dans votre poche.",
    "dlapp.sub": "Estimez votre or et votre argent où que vous soyez, suivez le prix du jour en direct et prenez rendez-vous en deux touches.",
    "dlapp.qrLink": "Voir la page de téléchargement avec QR code",
    "dlpage.eyebrow": "Télécharger",
    "dlpage.title2": "sur votre téléphone.",
    "dlpage.sub": "Scannez le QR code ou choisissez votre boutique : estimez votre or et votre argent au prix du jour, et prenez rendez-vous en deux touches.",
    "dlpage.downloadOn": "Télécharger sur",
    "dlpage.soonOn": "Bientôt sur",
    "dlpage.share": "Partager l'application",
    "dlpage.copy": "Copier le lien",
    "dlpage.copied": "Lien copié !",
    "dlpage.copyFail": "Copie impossible — ",
    "dlpage.qrCaption": "Scannez pour télécharger InstaGold Calc",
    "dlpage.step1t": "Scannez",
    "dlpage.step1d": "Pointez la caméra de votre téléphone sur le QR code.",
    "dlpage.step2t": "Installez",
    "dlpage.step2d": "Ouvrez le lien et installez InstaGold Calc en quelques secondes.",
    "dlpage.step3t": "Estimez",
    "dlpage.step3d": "Calculez la valeur de votre or en direct, où que vous soyez.",
    "contact.eyebrow": "Une question ?",
    "contact.call": "Appelez-nous",
    "contact.privacy": "Nous recueillons uniquement votre nom, téléphone, courriel, date, heure et secteur afin de vous contacter au sujet de votre rendez-vous. Ces données ne sont jamais vendues ni partagées avec des tiers.",
    "apt.formTitle": "Prendre rendez-vous",
    "apt.formSub": "Laissez vos coordonnées — attendez notre appel de confirmation.",
    "apt.name": "Nom",
    "apt.phone": "Téléphone",
    "apt.email": "Courriel",
    "apt.date": "Date souhaitée",
    "apt.time": "Heure souhaitée",
    "apt.youAre": "Vous êtes",
    "apt.in": "Dans Montréal",
    "apt.out": "À l'extérieur de Montréal",
    "apt.note": "Nous vous rappelons pour confirmer votre rendez-vous — attendez notre appel avant de vous déplacer.",
    "apt.submit": "Demander ce rendez-vous",
    "apt.sending": "Envoi…",
    "apt.successTitle": "Demande reçue !",
    "apt.successPre": "Merci ",
    "apt.successMid": ". Veuillez attendre notre appel de confirmation au ",
    "apt.successEnd": " — nous confirmons ensemble la date et l'heure de votre rendez-vous.",
    "apt.another": "Prendre un autre rendez-vous",
    "apt.namePh": "Votre nom",
    "apt.phonePh": "514-000-0000",
    "apt.emailPh": "vous@exemple.com",
    "buy.eyebrow": "Nous achetons",
    "buy.titlePre": "Nous achetons vos ",
    "buy.titleItalic": "trésors",
    "buy.sub": "Œuvres d'art, pièces de collection, montres, timbres, bijoux et objets de collection : nos experts évaluent et rachètent vos biens en toute confiance, au juste prix.",
    "buy.cat1t": "Œuvres d'art",
    "buy.cat1d": "Peintures, sculptures, dessins et gravures de toutes époques.",
    "buy.cat2t": "Pièces de collection",
    "buy.cat2d": "Pièces anciennes, monnaies rares et lingots.",
    "buy.cat3t": "Montres",
    "buy.cat3d": "Montres anciennes, de luxe et de collection, fonctionnelles ou non.",
    "buy.cat4t": "Timbres",
    "buy.cat4d": "Timbres classiques, collections complètes ou lots variés.",
    "buy.cat5t": "Bijoux",
    "buy.cat5d": "Bijoux anciens, pierres précieuses et créations signées.",
    "buy.cat6t": "Objets de collection",
    "buy.cat6d": "Antiquités, souvenirs historiques et pièces rares.",
    "buy.succT": "Ventes de succession",
    "buy.succD": "Nous prenons également en charge vos ventes de succession : inventaire complet, évaluation rigoureuse et mise en vente de l'ensemble des biens — bijoux, métaux précieux, œuvres d'art et objets de collection — avec discrétion et transparence.",
    "buy.formEyebrow": "Nous contacter",
    "buy.formTitleA": "Vendre ou faire",
    "buy.formTitleB": "estimer",
    "buy.formTitleC": "vos objets",
    "buy.formSub": "Écrivez-nous : décrivez ce que vous avez à vendre, ajoutez des photos et demandez votre estimation. Nous vous répondons rapidement — en toute confidentialité.",
    "buy.msgLabel": "Ce que vous avez à vendre",
    "buy.msgPh": "Décrivez vos objets : œuvres d'art, montres, timbres, bijoux, pièces… leur état, leur histoire, votre prix souhaité… Vous pouvez aussi y demander une estimation.",
    "buy.estimationChk": "Je souhaite une estimation de mes objets",
    "buy.photosLabel": "Photos de vos objets (jusqu'à 6)",
    "buy.addPhotos": "Ajouter des images",
    "buy.submit": "Envoyer mon message",
    "buy.sending": "Envoi…",
    "buy.successTitle": "Message envoyé !",
    "buy.successPre": "Merci ",
    "buy.successMid": ". Notre équipe examinera votre ",
    "buy.successMidEst": "demande d'estimation ",
    "buy.successMidMsg": "message ",
    "buy.successEnd": "et vous contactera rapidement au ",
    "buy.another": "Envoyer un autre message",
    "infos.eyebrow": "Infos",
    "infos.title1": "Tout savoir sur",
    "infos.title2": "l'or",
    "infos.ready": "Prêt(e) à vendre votre or ?",
    "infos.cta": "Calculer la valeur de mon or",
    "infos.m1t": "Inspection visuelle et poinçons",
    "infos.m1d": "Lecture des titres gravés (10K, 14K, 18K…) et des poinçons officiels.",
    "infos.m2t": "Test à l'acide sur pierre de touche",
    "infos.m2d": "Vérification de la réaction du métal pour confirmer le titre.",
    "infos.m3t": "Analyse électronique / XRF",
    "infos.m3d": "Spectrométrie sans dommage pour une lecture précise de la composition.",
    "infos.m4t": "Pesée précise",
    "infos.m4d": "Pesée sur balance certifiée, devant vous, au gramme près.",
    "about.eyebrow": "À propos",
    "about.title": "Encans Desparois",
    "about.storyT": "Notre histoire",
    "about.storyD": "Encans Desparois est une maison de ventes aux enchères spécialisée dans les bijoux, les métaux précieux, l'argent sterling et les objets de collection.",
    "about.missionT": "Notre mission",
    "about.missionD": "Permettre d'estimer rapidement et en toute transparence la valeur de votre or, de vos bijoux et de vos objets précieux avant de nous contacter.",
    "about.quote": "« Avec plus de 10 ans d'expérience dans l'achat, la vente et l'estimation d'or et de métaux précieux, notre commissaire-priseur Patrick Desparois vous garantit un service professionnel, rigoureux et transparent. »",
    "about.quoteRole": "Patrick Desparois — Commissaire-priseur",
    "about.platT": "Nos plateformes",
    "about.plat1": "Site officiel",
    "about.plat2": "Encans en direct",
    "about.plat3": "Plateforme internationale",
    "about.ctaT": "Une question ?",
    "about.ctaD": "Confidentialité garantie — vos estimations restent strictement privées.",
    "about.privacyT": "Politique de confidentialité",
    "about.privacyD": "Nous recueillons uniquement votre nom, téléphone, courriel, secteur et moment de rappel afin de vous contacter au sujet de votre vente. Ces données ne sont jamais vendues ni partagées avec des tiers et servent seulement à traiter votre demande. Pour consulter ou supprimer vos données, appelez-nous ou écrivez à estefanijewellery@gmail.com.",
    "inv.title": "Facture",
    "inv.client": "Client",
    "inv.contact": "Contact",
    "inv.date": "Date",
    "inv.description": "Description",
    "inv.total": "Total",
    "inv.payable": "Payable en personne — cash ou virement. Transaction encadrée par la maison de ventes aux enchères Encans Desparois, Montréal.",
    "inv.print": "Imprimer / Enregistrer en PDF",
    "inv.paid": "Payée",
    "inv.pending": "En attente de paiement",
    "inv.notFound": "Facture introuvable",
    "inv.back": "Retour à l'accueil",
    "toast.sendFail": "Envoi impossible — réessayez ou appelez-nous.",
    "footer.home": "Accueil",
    "footer.infos": "Infos",
    "footer.about": "À propos",
    "footer.buy": "Nous achetons",
    "footer.auctions": "Encans en direct",
    "footer.copyright": "© 2026 InstaGold Calc — Encans Desparois. Tous droits réservés.",
    "footer.admin": "Espace administrateur",
    "logo.tagline": "Montréal · Estimation d'or",
    "footer.privacy": "Confidentialité",
    "pp.eyebrow": "Confidentialité",
    "pp.h1": "Politique de confidentialité",
    "pp.updated": "Dernière mise à jour : octobre 2026",
    "pp.s1t": "Qui sommes-nous",
    "pp.s1d": "InstaGold Calc est exploité par la maison de ventes aux enchères Encans Desparois, à Montréal. Cette politique explique quelles données personnelles nous recueillons par ce site et comment nous les utilisons.",
    "pp.s2t": "Données que nous recueillons",
    "pp.s2d": "Selon votre utilisation : nom, téléphone et courriel lorsque vous demandez un rendez-vous ou nous écrivez au sujet d'objets à vendre ; date, heure et secteur de votre rendez-vous ; description de vos objets et photos que vous joignez ; préférence de langue. Le calculateur d'or ne recueille aucune donnée personnelle.",
    "pp.s3t": "Comment nous les utilisons",
    "pp.s3d": "Uniquement pour répondre à vos demandes : vous rappeler pour confirmer un rendez-vous, évaluer vos objets, vous transmettre une facture, et envoyer des notifications administratives à votre propre courriel si vous êtes le gérant. Nous ne faisons jamais de prospection sans votre consentement.",
    "pp.s4t": "Consentement",
    "pp.s4d": "Vous fournissez vos données volontairement lorsque vous soumettez un formulaire. Vous pouvez retirer votre consentement en tout temps en nous contactant.",
    "pp.s5t": "Conservation",
    "pp.s5d": "Nous conservons vos données le temps nécessaire au traitement de votre demande et à nos obligations légales, puis nous les supprimons. Les demandes non suivies d'une transaction sont supprimées au plus tard 24 mois après leur envoi.",
    "pp.s6t": "Partage",
    "pp.s6d": "Vos données ne sont jamais vendues. Elles ne sont partagées qu'avec les fournisseurs techniques strictement nécessaires (hébergement, envoi de courriels) et, si la loi l'exige, aux autorités compétentes.",
    "pp.s7t": "Stockage local et statistiques",
    "pp.s7d": "Ce site enregistre uniquement votre préférence de langue dans le stockage local de votre navigateur. Nos statistiques sont anonymes et agrégées : aucune donnée personnelle, aucun cookie publicitaire, aucun pisteur tiers.",
    "pp.s8t": "Sécurité",
    "pp.s8d": "Les échanges se font par connexion chiffrée. Les mots de passe administrateurs sont protégés par hachage bcrypt. L'accès aux données est limité au personnel autorisé d'Encans Desparois.",
    "pp.s9t": "Vos droits",
    "pp.s9d": "Conformément à la Loi modernisant des dispositions législatives en matière de protection des renseignements personnels (Québec) et à la LPRPDE, vous pouvez consulter, corriger, retirer ou faire supprimer vos données, et porter plainte auprès de la Commission d'accès à l'information du Québec.",
    "pp.s10t": "Nous joindre",
    "pp.s10d": "Pour toute question ou demande relative à vos données : estefanijewellery@gmail.com ou 514-378-8833. Nous répondons dans un délai maximal de 30 jours.",
  },
  en: {
    "page.title": "InstaGold Calc — How much is your gold worth? | Montreal",
    "nav.home": "Home",
    "nav.infos": "Info",
    "nav.about": "About",
    "nav.download": "Download the app",
    "hero.eyebrow": "InstaGold Calc — Montreal",
    "hero.t1": "How much is",
    "hero.t2a": "your",
    "hero.t2b": "gold",
    "hero.t2c": " worth?",
    "hero.sub": "Today's price, paid in cash or by transfer.",
    "hero.cta1": "Estimate my gold",
    "hero.cta2": "Download the app",
    "hero.tutorial": "Watch the tutorial",
    "common.close": "Close the tutorial",
    "testi.eyebrow": "Trusted by sellers",
    "testi.title1": "What our",
    "testi.title2": "sellers say",
    "testi.sub": "Jewellery, coins, watches and estates — here is what people say after selling with us.",
    "testi.1.text": "A delicate estate sale with dozens of pieces. They sorted and appraised everything piece by piece in a single visit. Rare professionalism.",
    "testi.2.text": "I was nervous about selling my jewellery. Every step was explained — non-damaging tests included — and I received the transfer the same day.",
    "testi.3.text": "The website calculator matches reality: my online estimate and the amount paid at the counter were identical. Total trust.",
    "marquee.1": "Free estimation",
    "marquee.2": "Cash or bank transfer",
    "marquee.3": "Gold 10K · 14K · 18K · 24K",
    "marquee.4": "Sterling silver",
    "marquee.5": "Guaranteed privacy",
    "marquee.6": "Official house — Encans Desparois",
    "calc.title": "Calculate the value of my gold",
    "calc.live": "Live market price",
    "calc.ref": "Reference price",
    "calc.gold": "Gold",
    "calc.silver": "Silver",
    "calc.platinum": "Platinum",
    "calc.weight": "Weight",
    "calc.grams": "grams",
    "calc.metalPrice": "Metal price",
    "calc.purity": "Purity",
    "calc.gross": "Gross value",
    "calc.rate": "Buyback rate",
    "calc.estimate": "Estimated payout",
    "calc.disclaimer": "Indicative estimate, no commitment. The final price is confirmed after testing your items.",
    "calc.book": "Book an appointment",
    "calc.modalSub": "Sell your gold — leave your details and choose when to come.",
    "trust.eyebrow": "Why sell to us",
    "trust.title1": "Trust,",
    "trust.title2": "engraved",
    "trust.title3": "in transparency.",
    "trust.c1t": "Guaranteed privacy",
    "trust.c1d": "Your personal estimates remain strictly private.",
    "trust.c2t": "Transparency & Rigour",
    "trust.c2d": "Valuations based on official precious metals prices.",
    "trust.c3t": "Official House",
    "trust.c3d": "Transactions overseen by the Encans Desparois auction house.",
    "trust.auctions": "Discover our live auctions",
    "trust.auctionsSub": "www.encansdesparois.com — jewelry, precious metals, collectibles",
    "banner.eyebrow": "We also buy",
    "banner.items": "Works of art · Collectible coins · Watches · Stamps · Jewelry · Collectibles",
    "banner.cta": "See what we buy",
    "evo.eyebrow": "The evolution of gold prices",
    "evo.ounce": "CA / ounce",
    "evo.caption": "Gold has more than multiplied by 10 since 2005 (in Canadian dollars). Now is the right time to sell.",
    "evo.chartTitle": "Gold price — 25 years (CA $/ounce)",
    "evo.chartSub": "Monthly averages",
    "dlapp.eyebrow": "The mobile app",
    "dlapp.title2": "in your pocket.",
    "dlapp.sub": "Estimate your gold and silver wherever you are, follow the live daily price and book an appointment in two taps.",
    "dlapp.qrLink": "Open the download page with QR code",
    "dlpage.eyebrow": "Download",
    "dlpage.title2": "on your phone.",
    "dlpage.sub": "Scan the QR code or choose your store: estimate your gold and silver at today's price and book an appointment in two taps.",
    "dlpage.downloadOn": "Download on",
    "dlpage.soonOn": "Coming to",
    "dlpage.share": "Share the app",
    "dlpage.copy": "Copy link",
    "dlpage.copied": "Link copied!",
    "dlpage.copyFail": "Copy failed — ",
    "dlpage.qrCaption": "Scan to download InstaGold Calc",
    "dlpage.step1t": "Scan",
    "dlpage.step1d": "Point your phone's camera at the QR code.",
    "dlpage.step2t": "Install",
    "dlpage.step2d": "Open the link and install InstaGold Calc in seconds.",
    "dlpage.step3t": "Estimate",
    "dlpage.step3d": "Calculate the value of your gold live, wherever you are.",
    "contact.eyebrow": "A question?",
    "contact.call": "Call us",
    "contact.privacy": "We only collect your name, phone, email, date, time and sector to contact you about your appointment. This data is never sold nor shared with third parties.",
    "apt.formTitle": "Book an appointment",
    "apt.formSub": "Leave your details — wait for our confirmation call.",
    "apt.name": "Name",
    "apt.phone": "Phone",
    "apt.email": "Email",
    "apt.date": "Preferred date",
    "apt.time": "Preferred time",
    "apt.youAre": "You are",
    "apt.in": "In Montreal",
    "apt.out": "Outside Montreal",
    "apt.note": "We will call you back to confirm your appointment — please wait for our call before coming.",
    "apt.submit": "Request this appointment",
    "apt.sending": "Sending…",
    "apt.successTitle": "Request received!",
    "apt.successPre": "Thank you ",
    "apt.successMid": ". Please wait for our confirmation call at ",
    "apt.successEnd": " — we will confirm the date and time of your appointment together.",
    "apt.another": "Book another appointment",
    "apt.namePh": "Your name",
    "apt.phonePh": "514-000-0000",
    "apt.emailPh": "you@example.com",
    "buy.eyebrow": "We buy",
    "buy.titlePre": "We buy your ",
    "buy.titleItalic": "treasures",
    "buy.sub": "Works of art, collectible coins, watches, stamps, jewelry and collectibles: our experts appraise and buy your goods with confidence, at the right price.",
    "buy.cat1t": "Works of art",
    "buy.cat1d": "Paintings, sculptures, drawings and prints from all eras.",
    "buy.cat2t": "Collectible coins",
    "buy.cat2d": "Antique coins, rare currencies and bullion.",
    "buy.cat3t": "Watches",
    "buy.cat3d": "Antique, luxury and collectible watches, working or not.",
    "buy.cat4t": "Stamps",
    "buy.cat4d": "Classic stamps, complete collections or mixed lots.",
    "buy.cat5t": "Jewelry",
    "buy.cat5d": "Antique jewelry, precious stones and signed pieces.",
    "buy.cat6t": "Collectibles",
    "buy.cat6d": "Antiques, historical memorabilia and rare pieces.",
    "buy.succT": "Estate sales",
    "buy.succD": "We also handle your estate sales: complete inventory, rigorous appraisal and sale of all goods — jewelry, precious metals, works of art and collectibles — with discretion and transparency.",
    "buy.formEyebrow": "Contact us",
    "buy.formTitleA": "Sell or get your",
    "buy.formTitleB": "items",
    "buy.formTitleC": "appraised",
    "buy.formSub": "Write to us: describe what you have to sell, add photos and request your appraisal. We reply quickly — in complete confidence.",
    "buy.msgLabel": "What you have to sell",
    "buy.msgPh": "Describe your items: works of art, watches, stamps, jewelry, coins… their condition, their story, your desired price… You can also request an appraisal there.",
    "buy.estimationChk": "I would like an appraisal of my items",
    "buy.photosLabel": "Photos of your items (up to 6)",
    "buy.addPhotos": "Add images",
    "buy.submit": "Send my message",
    "buy.sending": "Sending…",
    "buy.successTitle": "Message sent!",
    "buy.successPre": "Thank you ",
    "buy.successMid": ". Our team will review your ",
    "buy.successMidEst": "appraisal request ",
    "buy.successMidMsg": "message ",
    "buy.successEnd": "and will contact you shortly at ",
    "buy.another": "Send another message",
    "infos.eyebrow": "Info",
    "infos.title1": "Everything about",
    "infos.title2": "gold",
    "infos.ready": "Ready to sell your gold?",
    "infos.cta": "Calculate the value of my gold",
    "infos.m1t": "Visual inspection and hallmarks",
    "infos.m1d": "Reading engraved purities (10K, 14K, 18K…) and official hallmarks.",
    "infos.m2t": "Acid test on touchstone",
    "infos.m2d": "Checking the metal's reaction to confirm the purity.",
    "infos.m3t": "Electronic / XRF analysis",
    "infos.m3d": "Non-damaging spectrometry for an accurate composition reading.",
    "infos.m4t": "Precise weighing",
    "infos.m4d": "Weighed on a certified scale, in front of you, to the gram.",
    "about.eyebrow": "About",
    "about.title": "Encans Desparois",
    "about.storyT": "Our story",
    "about.storyD": "Encans Desparois is an auction house specializing in jewelry, precious metals, sterling silver and collectibles.",
    "about.missionT": "Our mission",
    "about.missionD": "To make it possible to quickly and transparently estimate the value of your gold, your jewelry and your precious items before contacting us.",
    "about.quote": "“With over 10 years of experience in buying, selling and appraising gold and precious metals, our auctioneer Patrick Desparois guarantees you a professional, rigorous and transparent service.”",
    "about.quoteRole": "Patrick Desparois — Auctioneer",
    "about.platT": "Our platforms",
    "about.plat1": "Official website",
    "about.plat2": "Live auctions",
    "about.plat3": "International platform",
    "about.ctaT": "A question?",
    "about.ctaD": "Privacy guaranteed — your estimates remain strictly private.",
    "about.privacyT": "Privacy policy",
    "about.privacyD": "We only collect your name, phone, email, sector and callback time to contact you about your sale. This data is never sold nor shared with third parties and is only used to process your request. To view or delete your data, call us or write to estefanijewellery@gmail.com.",
    "inv.title": "Invoice",
    "inv.client": "Client",
    "inv.contact": "Contact",
    "inv.date": "Date",
    "inv.description": "Description",
    "inv.total": "Total",
    "inv.payable": "Payable in person — cash or bank transfer. Transaction overseen by the Encans Desparois auction house, Montreal.",
    "inv.print": "Print / Save as PDF",
    "inv.paid": "Paid",
    "inv.pending": "Awaiting payment",
    "inv.notFound": "Invoice not found",
    "inv.back": "Back to home",
    "toast.sendFail": "Sending failed — try again or call us.",
    "footer.home": "Home",
    "footer.infos": "Info",
    "footer.about": "About",
    "footer.buy": "We buy",
    "footer.auctions": "Live auctions",
    "footer.copyright": "© 2026 InstaGold Calc — Encans Desparois. All rights reserved.",
    "footer.admin": "Administrator area",
    "logo.tagline": "Montreal · Gold estimation",
    "footer.privacy": "Privacy",
    "pp.eyebrow": "Privacy",
    "pp.h1": "Privacy Policy",
    "pp.updated": "Last updated: October 2026",
    "pp.s1t": "Who we are",
    "pp.s1d": "InstaGold Calc is operated by the Encans Desparois auction house in Montreal. This policy explains what personal data we collect through this site and how we use it.",
    "pp.s2t": "Data we collect",
    "pp.s2d": "Depending on your use: name, phone and email when you request an appointment or write to us about items to sell; the date, time and sector of your appointment; the description of your items and the photos you attach; your language preference. The gold calculator collects no personal data.",
    "pp.s3t": "How we use it",
    "pp.s3d": "Only to answer your requests: call you back to confirm an appointment, appraise your items, send you an invoice, and send administrative notifications to your own email if you are the manager. We never do marketing without your consent.",
    "pp.s4t": "Consent",
    "pp.s4d": "You provide your data voluntarily when you submit a form. You may withdraw your consent at any time by contacting us.",
    "pp.s5t": "Retention",
    "pp.s5d": "We keep your data only as long as needed to process your request and meet our legal obligations, then delete it. Requests not followed by a transaction are deleted at the latest 24 months after submission.",
    "pp.s6t": "Sharing",
    "pp.s6d": "Your data is never sold. It is only shared with the strictly necessary technical providers (hosting, email delivery) and, where the law requires it, with the competent authorities.",
    "pp.s7t": "Local storage and statistics",
    "pp.s7d": "This site only stores your language preference in your browser's local storage. Our statistics are anonymous and aggregated: no personal data, no advertising cookies, no third-party trackers.",
    "pp.s8t": "Security",
    "pp.s8d": "All exchanges use an encrypted connection. Administrator passwords are protected with bcrypt hashing. Access to data is limited to authorized Encans Desparois staff.",
    "pp.s9t": "Your rights",
    "pp.s9d": "In accordance with Quebec's Act to modernize legislative provisions as regards the protection of personal information and PIPEDA, you can access, correct, withdraw or have your data deleted, and file a complaint with the Commission d'accès à l'information du Québec.",
    "pp.s10t": "Contact us",
    "pp.s10d": "For any question or request about your data: estefanijewellery@gmail.com or 514-378-8833. We answer within 30 days at most.",
  },
  es: {
    "page.title": "InstaGold Calc — ¿Cuánto vale su oro? | Montreal",
    "nav.home": "Inicio",
    "nav.infos": "Info",
    "nav.about": "Nosotros",
    "nav.download": "Descargar la app",
    "hero.eyebrow": "InstaGold Calc — Montreal",
    "hero.t1": "¿Cuánto vale",
    "hero.t2a": "su",
    "hero.t2b": "oro",
    "hero.t2c": "?",
    "hero.sub": "Precio del día, pagado en efectivo o por transferencia.",
    "hero.cta1": "Evaluar mi oro",
    "hero.cta2": "Descargar la aplicación",
    "hero.tutorial": "Ver el tutorial",
    "common.close": "Cerrar el tutorial",
    "testi.eyebrow": "Vendedores satisfechos",
    "testi.title1": "Lo que dicen nuestros",
    "testi.title2": "vendedores",
    "testi.sub": "Joyas, monedas, relojes y sucesiones: esto dicen las personas que nos confiaron su oro.",
    "testi.1.text": "Una sucesión delicada con decenas de piezas. Lo clasificaron y tasaron pieza por pieza en una sola visita. Profesionalismo excepcional.",
    "testi.2.text": "Estaba nerviosa por vender mis joyas. Me explicaron cada paso —pruebas sin daños incluidas— y recibí la transferencia el mismo día.",
    "testi.3.text": "La calculadora del sitio es fiel a la realidad: mi estimación en línea y el monto recibido eran idénticos. Confianza total.",
    "marquee.1": "Evaluación gratuita",
    "marquee.2": "Pago en efectivo o transferencia",
    "marquee.3": "Oro 10K · 14K · 18K · 24K",
    "marquee.4": "Plata esterlina",
    "marquee.5": "Confidencialidad garantizada",
    "marquee.6": "Casa oficial — Encans Desparois",
    "calc.title": "Calcular el valor de mi oro",
    "calc.live": "Precio en vivo",
    "calc.ref": "Precio de referencia",
    "calc.gold": "Oro",
    "calc.silver": "Plata",
    "calc.platinum": "Platino",
    "calc.weight": "Peso",
    "calc.grams": "gramos",
    "calc.metalPrice": "Precio del metal",
    "calc.purity": "Pureza",
    "calc.gross": "Valor bruto",
    "calc.rate": "Tasa de compra",
    "calc.estimate": "Pago estimado",
    "calc.disclaimer": "Estimación orientativa, sin compromiso. El precio final se confirma después de probar sus artículos.",
    "calc.book": "Pedir una cita",
    "calc.modalSub": "Venda su oro — deje sus datos y elija cuándo venir.",
    "trust.eyebrow": "Por qué vendernos",
    "trust.title1": "La confianza,",
    "trust.title2": "grabada",
    "trust.title3": "en la transparencia.",
    "trust.c1t": "Confidencialidad garantizada",
    "trust.c1d": "Sus evaluaciones personales permanecen estrictamente privadas.",
    "trust.c2t": "Transparencia y Rigor",
    "trust.c2d": "Valoraciones basadas en los precios oficiales de los metales preciosos.",
    "trust.c3t": "Casa Oficial",
    "trust.c3d": "Transacciones supervisadas por la casa de subastas Encans Desparois.",
    "trust.auctions": "Descubra nuestras subastas en vivo",
    "trust.auctionsSub": "www.encansdesparois.com — joyas, metales preciosos, objetos de colección",
    "banner.eyebrow": "También compramos",
    "banner.items": "Obras de arte · Monedas de colección · Relojes · Sellos · Joyas · Objetos de colección",
    "banner.cta": "Descubra lo que compramos",
    "evo.eyebrow": "La evolución del precio del oro",
    "evo.ounce": "CA / onza",
    "evo.caption": "El oro se ha multiplicado por más de 10 desde 2005 (en dólares canadienses). Es el momento ideal para vender.",
    "evo.chartTitle": "Precio del oro — 25 años ($ CA / onza)",
    "evo.chartSub": "Promedios mensuales",
    "dlapp.eyebrow": "La aplicación móvil",
    "dlapp.title2": "en su bolsillo.",
    "dlapp.sub": "Evalúe su oro y su plata donde esté, siga el precio del día en vivo y pida una cita en dos toques.",
    "dlapp.qrLink": "Ver la página de descarga con código QR",
    "dlpage.eyebrow": "Descargar",
    "dlpage.title2": "en su teléfono.",
    "dlpage.sub": "Escanee el código QR o elija su tienda: evalúe su oro y su plata al precio del día y pida una cita en dos toques.",
    "dlpage.downloadOn": "Descargar en",
    "dlpage.soonOn": "Pronto en",
    "dlpage.share": "Compartir la aplicación",
    "dlpage.copy": "Copiar enlace",
    "dlpage.copied": "¡Enlace copiado!",
    "dlpage.copyFail": "No se pudo copiar — ",
    "dlpage.qrCaption": "Escanee para descargar InstaGold Calc",
    "dlpage.step1t": "Escanee",
    "dlpage.step1d": "Apunte la cámara de su teléfono al código QR.",
    "dlpage.step2t": "Instale",
    "dlpage.step2d": "Abra el enlace e instale InstaGold Calc en segundos.",
    "dlpage.step3t": "Evalúe",
    "dlpage.step3d": "Calcule el valor de su oro en vivo, donde esté.",
    "contact.eyebrow": "¿Una pregunta?",
    "contact.call": "Llámenos",
    "contact.privacy": "Solo recopilamos su nombre, teléfono, correo, fecha, hora y sector para contactarle sobre su cita. Estos datos nunca se venden ni se comparten con terceros.",
    "apt.formTitle": "Pedir una cita",
    "apt.formSub": "Deje sus datos — espere nuestra llamada de confirmación.",
    "apt.name": "Nombre",
    "apt.phone": "Teléfono",
    "apt.email": "Correo electrónico",
    "apt.date": "Fecha deseada",
    "apt.time": "Hora deseada",
    "apt.youAre": "Usted está",
    "apt.in": "En Montreal",
    "apt.out": "Fuera de Montreal",
    "apt.note": "Le llamaremos para confirmar su cita — espere nuestra llamada antes de desplazarse.",
    "apt.submit": "Solicitar esta cita",
    "apt.sending": "Enviando…",
    "apt.successTitle": "¡Solicitud recibida!",
    "apt.successPre": "Gracias ",
    "apt.successMid": ". Espere nuestra llamada de confirmación al ",
    "apt.successEnd": " — confirmaremos juntos la fecha y la hora de su cita.",
    "apt.another": "Pedir otra cita",
    "apt.namePh": "Su nombre",
    "apt.phonePh": "514-000-0000",
    "apt.emailPh": "usted@ejemplo.com",
    "buy.eyebrow": "Compramos",
    "buy.titlePre": "Compramos sus ",
    "buy.titleItalic": "tesoros",
    "buy.sub": "Obras de arte, monedas de colección, relojes, sellos, joyas y objetos de colección: nuestros expertos evalúan y compran sus bienes con confianza, al precio justo.",
    "buy.cat1t": "Obras de arte",
    "buy.cat1d": "Pinturas, esculturas, dibujos y grabados de todas las épocas.",
    "buy.cat2t": "Monedas de colección",
    "buy.cat2d": "Monedas antiguas, monedas raras y lingotes.",
    "buy.cat3t": "Relojes",
    "buy.cat3d": "Relojes antiguos, de lujo y de colección, funcionales o no.",
    "buy.cat4t": "Sellos",
    "buy.cat4d": "Sellos clásicos, colecciones completas o lotes variados.",
    "buy.cat5t": "Joyas",
    "buy.cat5d": "Joyas antiguas, piedras preciosas y piezas firmadas.",
    "buy.cat6t": "Objetos de colección",
    "buy.cat6d": "Antigüedades, recuerdos históricos y piezas raras.",
    "buy.succT": "Ventas de sucesión",
    "buy.succD": "También nos encargamos de sus ventas de sucesión: inventario completo, valoración rigurosa y venta de todos los bienes — joyas, metales preciosos, obras de arte y objetos de colección — con discreción y transparencia.",
    "buy.formEyebrow": "Contáctenos",
    "buy.formTitleA": "Vender o hacer",
    "buy.formTitleB": "tasar",
    "buy.formTitleC": "sus objetos",
    "buy.formSub": "Escríbanos: describa lo que tiene que vender, añada fotos y solicite su tasación. Le respondemos rápidamente — con total confidencialidad.",
    "buy.msgLabel": "Lo que tiene que vender",
    "buy.msgPh": "Describa sus objetos: obras de arte, relojes, sellos, joyas, monedas… su estado, su historia, su precio deseado… También puede solicitar una tasación.",
    "buy.estimationChk": "Deseo una tasación de mis objetos",
    "buy.photosLabel": "Fotos de sus objetos (hasta 6)",
    "buy.addPhotos": "Añadir imágenes",
    "buy.submit": "Enviar mi mensaje",
    "buy.sending": "Enviando…",
    "buy.successTitle": "¡Mensaje enviado!",
    "buy.successPre": "Gracias ",
    "buy.successMid": ". Nuestro equipo revisará su ",
    "buy.successMidEst": "solicitud de tasación ",
    "buy.successMidMsg": "mensaje ",
    "buy.successEnd": "y le contactará pronto al ",
    "buy.another": "Enviar otro mensaje",
    "infos.eyebrow": "Info",
    "infos.title1": "Todo sobre",
    "infos.title2": "el oro",
    "infos.ready": "¿Listo(a) para vender su oro?",
    "infos.cta": "Calcular el valor de mi oro",
    "infos.m1t": "Inspección visual y punzones",
    "infos.m1d": "Lectura de las purezas grabadas (10K, 14K, 18K…) y de los punzones oficiales.",
    "infos.m2t": "Prueba de ácido en piedra de toque",
    "infos.m2d": "Verificación de la reacción del metal para confirmar la pureza.",
    "infos.m3t": "Análisis electrónico / XRF",
    "infos.m3d": "Espectrometría sin daños para una lectura precisa de la composición.",
    "infos.m4t": "Pesaje preciso",
    "infos.m4d": "Pesaje en balanza certificada, delante de usted, al gramo.",
    "about.eyebrow": "Nosotros",
    "about.title": "Encans Desparois",
    "about.storyT": "Nuestra historia",
    "about.storyD": "Encans Desparois es una casa de subastas especializada en joyas, metales preciosos, plata esterlina y objetos de colección.",
    "about.missionT": "Nuestra misión",
    "about.missionD": "Permitir estimar rápida y transparentemente el valor de su oro, sus joyas y sus objetos preciosos antes de contactarnos.",
    "about.quote": "«Con más de 10 años de experiencia en la compra, venta y tasación de oro y metales preciosos, nuestro subastador Patrick Desparois le garantiza un servicio profesional, riguroso y transparente.»",
    "about.quoteRole": "Patrick Desparois — Subastador",
    "about.platT": "Nuestras plataformas",
    "about.plat1": "Sitio oficial",
    "about.plat2": "Subastas en vivo",
    "about.plat3": "Plataforma internacional",
    "about.ctaT": "¿Una pregunta?",
    "about.ctaD": "Confidencialidad garantizada — sus evaluaciones permanecen estrictamente privadas.",
    "about.privacyT": "Política de privacidad",
    "about.privacyD": "Solo recopilamos su nombre, teléfono, correo, sector y momento de llamada para contactarle sobre su venta. Estos datos nunca se venden ni se comparten con terceros y solo se usan para procesar su solicitud. Para consultar o eliminar sus datos, llámenos o escriba a estefanijewellery@gmail.com.",
    "inv.title": "Factura",
    "inv.client": "Cliente",
    "inv.contact": "Contacto",
    "inv.date": "Fecha",
    "inv.description": "Descripción",
    "inv.total": "Total",
    "inv.payable": "Pagadero en persona — efectivo o transferencia. Transacción supervisada por la casa de subastas Encans Desparois, Montreal.",
    "inv.print": "Imprimir / Guardar en PDF",
    "inv.paid": "Pagada",
    "inv.pending": "Pendiente de pago",
    "inv.notFound": "Factura no encontrada",
    "inv.back": "Volver al inicio",
    "toast.sendFail": "No se pudo enviar — inténtelo de nuevo o llámenos.",
    "footer.home": "Inicio",
    "footer.infos": "Info",
    "footer.about": "Nosotros",
    "footer.buy": "Compramos",
    "footer.auctions": "Subastas en vivo",
    "footer.copyright": "© 2026 InstaGold Calc — Encans Desparois. Todos los derechos reservados.",
    "footer.admin": "Área de administrador",
    "logo.tagline": "Montreal · Tasación de oro",
    "footer.privacy": "Privacidad",
    "pp.eyebrow": "Privacidad",
    "pp.h1": "Política de privacidad",
    "pp.updated": "Última actualización: octubre de 2026",
    "pp.s1t": "Quiénes somos",
    "pp.s1d": "InstaGold Calc es operado por la casa de subastas Encans Desparois, en Montreal. Esta política explica qué datos personales recopilamos a través de este sitio y cómo los utilizamos.",
    "pp.s2t": "Datos que recopilamos",
    "pp.s2d": "Según su uso: nombre, teléfono y correo cuando solicita una cita o nos escribe sobre objetos para vender; la fecha, la hora y el sector de su cita; la descripción de sus objetos y las fotos que adjunta; su preferencia de idioma. La calculadora de oro no recopila ningún dato personal.",
    "pp.s3t": "Cómo los utilizamos",
    "pp.s3d": "Únicamente para responder a sus solicitudes: llamarle para confirmar una cita, evaluar sus objetos, enviarle una factura y enviar notificaciones administrativas a su propio correo si es el gerente. Nunca hacemos prospección sin su consentimiento.",
    "pp.s4t": "Consentimiento",
    "pp.s4d": "Usted proporciona sus datos voluntariamente al enviar un formulario. Puede retirar su consentimiento en cualquier momento contactándonos.",
    "pp.s5t": "Conservación",
    "pp.s5d": "Conservamos sus datos solo el tiempo necesario para procesar su solicitud y cumplir nuestras obligaciones legales, y luego los eliminamos. Las solicitudes sin transacción se eliminan a más tardar 24 meses después de su envío.",
    "pp.s6t": "Compartición",
    "pp.s6d": "Sus datos nunca se venden. Solo se comparten con los proveedores técnicos estrictamente necesarios (alojamiento, envío de correos) y, cuando la ley lo exige, con las autoridades competentes.",
    "pp.s7t": "Almacenamiento local y estadísticas",
    "pp.s7d": "Este sitio solo guarda su preferencia de idioma en el almacenamiento local de su navegador. Nuestras estadísticas son anónimas y agregadas: ningún dato personal, ninguna cookie publicitaria, ningún rastreador de terceros.",
    "pp.s8t": "Seguridad",
    "pp.s8d": "Los intercambios se realizan mediante conexión cifrada. Las contraseñas de administrador están protegidas con hash bcrypt. El acceso a los datos está limitado al personal autorizado de Encans Desparois.",
    "pp.s9t": "Sus derechos",
    "pp.s9d": "De acuerdo con la ley de Québec que moderniza la protección de los datos personales y la LPRPDE, puede consultar, corregir, retirar o solicitar la eliminación de sus datos, y presentar una queja ante la Commission d'accès à l'information du Québec.",
    "pp.s10t": "Contáctenos",
    "pp.s10d": "Para cualquier pregunta o solicitud sobre sus datos: estefanijewellery@gmail.com o 514-378-8833. Respondemos en un plazo máximo de 30 días.",
  },
};
